__turbopack_context__.v({
  "container": "XtNjKq_container",
  "productBreadcrumbs": "XtNjKq_productBreadcrumbs",
  "productBreadcrumbsWithSearchbar": "XtNjKq_productBreadcrumbsWithSearchbar",
  "skeleton": "XtNjKq_skeleton",
});
